import gql from 'graphql-tag';

export class SettingsQueries {
  static integrationsStatus = gql`
    query IntegrationsStatus {
      integrations {
        name
        status
      }
    }
  `;

  static integrationDetails = gql`
    query IntegrationsDetails($name: String!) {
      integration(name: $name) {
        externalUrl
        token
        identifier
        metaData1
        metaData2
        metaData3
        name
        profile
        status
        userId
      }
    }
  `;
}
